// Tab List (FilterCategory)
export const TabList = [
	{
		id: "ongoing",
		title: "Ongoing applications",
	},
	{
		id: "submitted",
		title: "Submitted applications",
	},
	{
		id: "completed",
		title: "Completed applications",
	},
	{
		id: "savings",
		title: "Savings",
	},
];

export const TabList1 = [
	{
		id: "ongoing",
		title: "Ongoing applications",
	},
	{
		id: "submitted",
		title: "Submitted applications",
	},
	{
		id: "completed",
		title: "Completed applications",
	},
	{
		id: "savings",
		title: "Savings",
	},
];

export const TabList2 = [
	{
		id: "created_assets",
		title: "Created Requests",
	},
	{
		id: "inactive",
		title: "Inactive Requests",
	},
	{
		id: "active",
		title: "Active Requests",
	},
	{
		id: "funded",
		title: "Funded Requests",
	},
];

// Table Head Cells
export const OngoingHeader = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "trnId", title: "TRANSACTION ID", width: 167 },
	{ field: "type", title: "AF TYPE", width: 60 },
	{ field: "businessType", title: "BUSINESS TYPE", width: 60 },
	{ field: "apprentice", title: "APPRENTICE", width: 80 },
	{ field: "amount", title: "AMOUNT TO RAISE", width: 120 },
	{ field: "expectedProfit", title: "EXPECTED PROFIT", sortable: false, width: 60 },
	{ field: "interestRate", title: "INTEREST", sortable: false, width: 60 },
	{ field: "request", title: "REQUEST", sortable: false, width: 60 },
	{ field: "approvalStatus", title: "APPROVAL", sortable: false, width: 60 },
	{ field: "", title: "ACTION", sortable: false, width: 60 },
];

export const SubmittedHeader = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	// { field: "BusinessInterest", title: "BUSINESS INTEREST", width: 60 },
	{ field: "investorFinanceInfo.financeId", title: "FINANCE ID", width: 60 },
	{ field: "type", title: "AF TYPE", width: 60 },
	{ field: "apprentice", title: "APPRENTICE", width: 80 },
	{ field: "amountToRaise", title: "AMOUNT TO RAISE", width: 120 },
	{ field: "interestRate", title: "INTEREST", sortable: false, width: 60 },
	{ field: "businessType", title: "BUSINESS TYPE", sortable: false, width: 60 },
	{ field: "purpose", title: "PURPOSE", sortable: false, width: 60 },
	{ field: "request", title: "REQUEST", sortable: false, width: 60 },
	{ field: "approvalStatus", title: "APPROVAL", sortable: false, width: 60 },
	{ field: "", title: "ACTION", sortable: false, width: 70 },
];

export const CompletedHeader = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "trnId", title: "TRANSACTION ID", width: 167 },
	{ field: "type", title: "AF TYPE", width: 60 },
	{ field: "businessType", title: "BUSINESS INTEREST", width: 60 },
	{ field: "apprentice", title: "APPRENTICE", width: 80 },
	{ field: "amountToRaise", title: "AMOUNT TO RAISE", width: 120 },
	{ field: "expectedProfit", title: "EXPECTED PROFIT", sortable: false, width: 60 },
	{ field: "interestRate", title: "INTEREST", sortable: false, width: 60 },
	{ field: "request", title: "REQUEST", sortable: false, width: 60 },
	{ field: "approvalStatus", title: "APPROVAL", sortable: false, width: 60 },
	{ field: "", title: "ACTION", sortable: false, width: 60 },
];

export const CreatedAssetsHeader = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "businessType", title: "BUSINESS INTEREST", width: 60 },
	{ field: "type", title: "AF TYPE", width: 60 },
	{ field: "investorInfo.name", title: "INVESTOR", width: 70 },
	{ field: "amountToInvest", title: "AMOUNT TO INVEST", width: 120 },
	{ field: "amountToRepay", title: "AMOUNT TO REPAY", width: 120 },
	{ field: "duration", title: "FINANCE DURATION", width: 120 },
	{ field: "interestRate", title: "INTEREST", sortable: false, width: 60 },
	{ field: "", title: "ACTION", sortable: false, width: 70 },
];

export const SavingsHeader = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "savingsType", title: "SAVINGS TYPE", width: 100 },
	{ field: "asset", title: "ASSET", width: 100 },
	{ field: "frequency", title: "FREQUENCY", width: 80 },
	{ field: "dayOfTheMonth", title: "DAY OF MONTH", width: 100 },
	{ field: "tenure", title: "TENOR", width: 70 },
	{ field: "amountToSave", title: "AMOUNT", width: 110 },
	{ field: "interestRate", title: "INTEREST", width: 70 },
	{ field: "automation", title: "AUTOMATION", width: 70 },
	{ field: "paymentMode", title: "PAYMENT MODE", sortable: false, width: 70 },
	{ field: "", title: "ACTION", sortable: false, width: 70 },
];
